export const entityPrefixByType = {
  convention: 'cnv',
  coAction: 'act',
  plan: 'pln',
  completionReport: 'rpt',
  postMortem: 'pmt',
  codeReview: 'rev',
  codeReviewFinding: 'rvf',
  planTask: 'tsk',
  document: 'doc',
  skill: 'skl',
} as const;

type EntityType = keyof typeof entityPrefixByType;

const entityPrefixes = Object.values(entityPrefixByType);
const uuidBodyPattern = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
const prefixedIdPattern = new RegExp(`^(?:agentteams_)?(?:${entityPrefixes.join('|')})_(${uuidBodyPattern})$`);

const prefixByEntityType = (entityType: string): string | null => {
  if (
    entityType === 'convention' ||
    entityType === 'coAction' ||
    entityType === 'plan' ||
    entityType === 'completionReport' ||
    entityType === 'postMortem' ||
    entityType === 'codeReview' ||
    entityType === 'codeReviewFinding' ||
    entityType === 'planTask' ||
    entityType === 'document' ||
    entityType === 'skill'
  ) {
    return entityPrefixByType[entityType as EntityType];
  }

  return null;
};

export const stripEntityIdPrefix = (value: string): string => {
  const matched = value.match(prefixedIdPattern);
  if (!matched) {
    return value;
  }

  return matched[1] ?? value;
};

export const withEntityIdPrefix = (entityType: string, id: string): string => {
  if (!id) {
    return id;
  }

  if (stripEntityIdPrefix(id) !== id) {
    return id;
  }

  const prefix = prefixByEntityType(entityType);
  if (!prefix) {
    return id;
  }

  return `agentteams_${prefix}_${id}`;
};
